module.exports = "<promotion-page></promotion-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/promotion.html
// module id = 1430
// module chunks = 0